function JobMetadataGrid({ heading = '', metadata = [] }) {
  if (!metadata.length) {
    return null;
  }

  return (
    <div className="job-metadata">
      {heading ? <p className="job-metadata__eyebrow">{heading}</p> : null}
      <dl className="job-metadata-grid">
        {metadata.map((item, index) => (
          <div className="job-meta-pill" key={`${item.label}-${index}`}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default JobMetadataGrid;
